import React, { useEffect, useState } from "react";
import {
  InputLabel,
  IconButton,
  InputAdornment,
  TextField,
  Grid,
} from "@mui/material";
import { Col, Container, Row, Form } from "react-bootstrap";
import Button from "@mui/material/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { createScheduleQuery } from "../../api/fileInfoReportApi/fileInfoReportApi";
import moment from "moment";
import { useLoader } from "../../context/LoaderContext";
import { useSnackbar } from "../Common/SnackbarContext";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LocalStorageUtil from "../../utils/localStorage";
import { appSettings } from "../../config/appSetting";

function not(a: readonly number[], b: readonly number[]) {
  return a.filter((value) => !b.includes(value));
}

function intersectionLeft(a: readonly number[], b: any) {
  return b.filter((column: any) => a.includes(column?.metaDataFieldId));
}

function intersectionRight(a: readonly number[], b: any) {
  return b?.filter((column: any) =>
    a?.includes(column?.metaDataFieldId || column?.fileInfoReportID)
  );
}

interface Option {
  value: number;
  label: string;
}

interface Category {
  label: string;
  options: Option[];
}
interface EditReportDataProps {
  leftData: any;
  fieldsData: any;
  isOpen: any;
  savedQueryDetails: any;
  getData: any;
  handleCallback: () => void;
  getDataPayload: any;
  clearTrigger: any;
  setSavedQueryDetails: any,
  saveQuery: any
}

const ScheduleFileInfoReport: React.FC<EditReportDataProps> = ({
  leftData,
  fieldsData,
  isOpen,
  savedQueryDetails,
  getData,
  handleCallback,
  getDataPayload,
  clearTrigger,
  setSavedQueryDetails,
  saveQuery
}) => {
  const [startDate, setStartDate] = useState<Date | null | undefined>(() => {
    if (!savedQueryDetails?.schedularData?.length) return;
    const savedStartDate = savedQueryDetails?.schedularData[0]?.startDate;
    return savedStartDate
      ? new Date(savedStartDate)
      : new Date(new Date().setDate(new Date().getDate() - 1));
  });

  const [endDate, setEndDate] = useState<Date | null | undefined>(() => {
    if (!savedQueryDetails?.schedularData?.length) return;
    const savedEndDate = savedQueryDetails?.schedularData[0]?.endDate;
    return savedEndDate ? new Date(savedEndDate) : new Date();
  });

  const [selectedRepeat, setSelectedRepeat] = useState("1");
  const [repeatValue, setRepeatValue] = useState(1);
  const [formData, setFormData] = useState({
    reportName: "",
    toEmail: "",
    bccEmail: "",
    ccEmail: "",
    emailId: "",
    reportFormat: "",
    isPublic: false,
  });
  const { setLoading } = useLoader();
  const { showSnackbar } = useSnackbar();
  useEffect(() => {
    if (!savedQueryDetails?.schedularData?.length) return;
    setFormData({
      reportName: savedQueryDetails?.schedularData[0]?.reportName || "",
      toEmail: savedQueryDetails?.schedularData[0]?.toEmail || "",
      bccEmail: savedQueryDetails?.schedularData[0]?.bccEmail || "",
      ccEmail: savedQueryDetails?.schedularData[0]?.ccEmail || "",
      emailId: savedQueryDetails?.schedularData[0]?.reportName || "",
      reportFormat:
        savedQueryDetails?.listSearchCriteriaDetailsModel[0]?.reportType || "",
      isPublic:
        savedQueryDetails?.listSearchCriteriaDetailsModel[0]?.isPublic || false,
    });
    setSelectedRepeat(
      savedQueryDetails?.schedularData[0]?.repeatType.toString()
    );
    setRepeatValue(savedQueryDetails?.schedularData[0]?.repeatFrequency);
    setStartDate(
      savedQueryDetails?.schedularData[0]?.startDate
        ? new Date(savedQueryDetails?.schedularData[0]?.startDate)
        : new Date(new Date().setDate(new Date().getDate() - 1))
    );
    setEndDate(
      savedQueryDetails?.schedularData[0]?.endDate
        ? new Date(savedQueryDetails?.schedularData[0]?.endDate)
        : new Date()
    );
    const repeatOnValue = savedQueryDetails?.schedularData[0]?.repeatOn;
    if (Array.isArray(repeatOnValue)) {
      setRepeatOn(repeatOnValue);
    } else if (typeof repeatOnValue === "number") {
      const selectedIds = daysArray
        .filter((day) => (repeatOnValue & day.id) === day.id)
        .map((day) => day.id);
      setRepeatOn(selectedIds);
    } else {
      setRepeatOn([]);
    }
  }, [savedQueryDetails]);
  const [formErrors, setFormErrors] = useState({
    reportName: "",
    toEmail: "",
    bccEmail: "",
    ccEmail: "",
  });

  const [criteria, setCriteria] = useState([
    { id: Date.now(), condition: "", field: "", operator: "", value: "" },
  ]);
  const [searchTermLeft, setSearchTermLeft] = useState("");
  const [searchTermRight, setSearchTermRight] = useState("");
  const [checked, setChecked] = React.useState<readonly number[]>([]);
  const [left, setLeft] = useState<readonly number[]>([]);
  const [right, setRight] = useState<any>([]);
  const [history, setHistory] = useState<
    Array<{
      left: readonly number[];
      right: readonly number[];
      checked: readonly number[];
    }>
  >([]);  
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [errors, setErrors] = useState<{
      sourceNameError?: string,
      selectedFieldsError?: string,
  }>({});

const [criteriaErrors, setCriteriaErrors] = useState<any[]>([]);

  useEffect(() => {
    if (savedQueryDetails?.listSearchCriteriaDetailsModel?.length) {
      const mappedCriteria =
        savedQueryDetails.listSearchCriteriaDetailsModel.map((item: any) => ({
          id: item?.searchCriteriaID,
          condition: item?.logicalOperator,
          field: item?.metadataFieldName,
          operator: item?.operator,
          value: item?.value1,
        }));
      setCriteria(mappedCriteria);
    } else {
      setCriteria([
        { id: Date.now(), condition: "", field: "", operator: "", value: "" },
      ]);
    }
  }, [savedQueryDetails]);

  // Removed Unused handleToggleAll method

  // Removed Unused handleAllRight method

  // Removed Unused handleCheckedRight method

  // Removed Unused handleCheckedLeft method

  // Removed Unused handleAllLeft method

  const saveToHistory = () => {
    setHistory((prev) => [...prev, { left, right, checked }]);
  };

  const undoLastAction = () => {
    if (history.length > 0) {
      const lastState = history[history.length - 1];
      setLeft(lastState.left);
      setRight(lastState.right);
      setChecked(lastState.checked);
      setHistory((prev) => prev.slice(0, -1));
    }
  };

  const handleDragEnd = (result: any) => {
    const { source, destination } = result;
    if (!destination) return;
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }
    saveToHistory();
    if (source.droppableId === "available" && destination.droppableId === "enabled") {
      const movedItem = left[source.index];
      const newLeft = [...left];
      newLeft.splice(source.index, 1);
      const newRight = [...right, movedItem];
      setLeft(newLeft);
      setRight(newRight);
    } else if (source.droppableId === "enabled" && destination.droppableId === "available") {
      const movedItem = right[source.index];
      const newRight = [...right];
      newRight.splice(source.index, 1);
      const newLeft = [...left, movedItem];
      setRight(newRight);
      setLeft(newLeft);
    }
     if(source.droppableId === "available" && destination.droppableId === "available"){
      const movedItem = left[source.index];
      const leftItems = [...left];
      leftItems.splice(source.index, 1);
      const newLeft = [...leftItems];
      newLeft.splice(destination.index, 0, movedItem);
      setLeft(newLeft);
    }
    if(source.droppableId === "enabled" && destination.droppableId === "enabled"){
      const movedItem = right[source.index];
      const rightItems = [...right];
      rightItems.splice(source.index, 1);
      const newRight = [...rightItems];
      newRight.splice(destination.index, 0, movedItem);
      setRight(newRight);
    }
  };

  const addCriteria = () => {
    setCriteria([
      ...criteria,
      { id: Date.now(), condition: "", field: "", operator: "", value: "" },
    ]);
  };

  const removeCriteria = (id: any) => {
    setCriteria(criteria.filter((item) => item.id !== id));
  };

  const handleCriteriaChange = (id: any, event: any) => {
    const { name, value } = event.target;
    setCriteria((prevCriteria) =>
      prevCriteria.map((item) =>
        item.id === id ? { ...item, [name]: value } : item
      )
    );
  };

  // Removed Unused customListLeft method

  // Removed Unused customListRight method

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTermLeft(event.target.value);
  };

  const handleSearchChangeRight = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchTermRight(event.target.value);
  };

  const validateEmail = (
    emailValue: string,
    emailType: "toEmail" | "ccEmail" | "bccEmail"
  ) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.exec(emailValue)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [emailType]: "Please enter a valid email address.",
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [emailType]: "",
      }));
    }
  };

  const daysArray = [
    { id: 1, day: "S" },
    { id: 2, day: "M" },
    { id: 4, day: "T" },
    { id: 8, day: "W" },
    { id: 16, day: "T" },
    { id: 32, day: "F" },
    { id: 64, day: "S" },
  ];

  const operator = [
    {
      value: "Equals",
      label: "Exactly Matches =",
    },
    {
      value: "NotEqualString",
      label: "Does Not Contain",
    },
    {
      value: "StartsWith",
      label: "Begins with",
    },
    {
      value: "EndsWith",
      label: "Ends with",
    },
    {
      value: "Contains",
      label: "Contains",
    },
    {
      value: "IN",
      label: "IN",
    },
  ];

  const dateOperator = [
    {
      value: "Equals",
      label: "Exactly Matches =",
    },
    {
      value: "GreaterThan",
      label: "Greater than >",
    },
    {
      value: "GreaterThanOrEqual",
      label: "Greater or equal >=",
    },
    {
      value: "LessThan",
      label: "Less than <",
    },
    {
      value: "LessThanOrEqual",
      label: "Less or equal <=",
    },
    {
      value: "NotEqual",
      label: "Not equal <>",
    },
    {
      value: "Between",
      label: "Between",
    },
  ];

  const repeatOnValue = Array.isArray(savedQueryDetails?.schedularData)
    ? savedQueryDetails?.schedularData[0]?.repeatOn || ""
    : "";

  const [repeatOn, setRepeatOn] = useState<number[]>(() => {
    if (Array.isArray(repeatOnValue)) {
      return repeatOnValue;
    }
    if (typeof repeatOnValue === "number") {
      return daysArray
        .filter((dayObj) => (repeatOnValue & dayObj.id) === dayObj.id)
        .map((dayObj) => dayObj.id);
    }
    return [];
  });

  const ScheduleData = [
    { id: 1, record: "Daily" },
    { id: 2, record: "Every weekday (Monday to Friday)" },
    { id: 3, record: "Every Monday, Wednesday, and Friday" },
    { id: 4, record: "Every Tuesday and Thursday" },
    { id: 5, record: "Weekly" },
    { id: 6, record: "Bi-Weekly (1st & 16th)" },
    { id: 7, record: "Monthly" },
    { id: 8, record: "Yearly" },
  ];

  const ScheduleDay = [
    { id: 1, record: 1 },
    { id: 2, record: 2 },
    { id: 3, record: 3 },
    { id: 4, record: 4 },
    { id: 5, record: 5 },
    { id: 6, record: 6 },
    { id: 7, record: 7 },
    { id: 8, record: 8 },
    { id: 9, record: 9 },
    { id: 10, record: 10 },
    { id: 11, record: 11 },
    { id: 12, record: 12 },
    { id: 13, record: 13 },
    { id: 14, record: 14 },
    { id: 15, record: 15 },
  ];

  const handleRepeatChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedRepeat(e.target.value);
  };

  const handleRepeatValueChange = (e: any) => {
    setRepeatValue(e.target.value);
  };

  const handleDayChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    dayId: number
  ) => {
    if (e.target.checked) {
      setRepeatOn((prev) => [...prev, dayId]);
    } else {
      setRepeatOn((prev) => prev.filter((id) => id !== dayId));
    }
  };

  const handleChange = (event: any) => {
    const { name, value, type, checked } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (name === "bccEmail" || name === "ccEmail" || name === "toEmail") {
      validateEmail(value, name);
    }
  };

  const handleConfirmDialogClose = (confirmed: boolean) => {
    setConfirmDialogOpen(false);
    if (confirmed) {
      setRight([]);
      setCriteria((prevState) =>
        prevState.map((item) => ({
          ...item,
          condition: "",
          field: "",
          operator: "",
          value: "",
        }))
      );
      setFormData({
        reportName: "",
        toEmail: "",
        bccEmail: "",
        ccEmail: "",
        emailId: "",
        reportFormat: "",
        isPublic: false,
      });
    }
  };

  const handleCancelClick = () => {
    setConfirmDialogOpen(true);
    handleCallback();
  };

  useEffect(() => {
    if (isOpen) {
      setLeft(leftData);
    }
    if (savedQueryDetails?.fileInfoReportField) {
      setRight(savedQueryDetails?.fileInfoReportField);
    }
  }, [isOpen]);

  const generateSearchCriterias = (data: any) => {
    return criteria?.map((item: any, index) => {
      const matchedField = data.filter((d: any) => d.field === item.field) || {};
      return {
        LogicalOperator: index === 0 ? null : item.condition || "AND",
        Fielditem: {
          metaDataFieldId: matchedField[0]?.metaDataFieldId ?? null,
          field: item.field,
          customField: item.customField || item.field,
          categoryName: matchedField[0]?.categoryName ?? "General Information",
          fieldMappingId: matchedField[0]?.fieldMappingId ?? null,
        },
        Operator: item.operator || "Equals",
        Value1: item.value ?? "",
        Value2: null,
        Field: matchedField[0]?.metaDataFieldId ?? null,
        FieldName: item.field,
        MetadataFieldName: item.field ?? null,
        SearchCriteriaID:
          savedQueryDetails?.listSearchCriteriaDetailsModel?.[0]
            ?.searchCriteriaID,
        SearchQueryID:
          savedQueryDetails?.listSearchCriteriaDetailsModel?.[0]?.searchQueryID,
      };
    });
  };

  const generateFileInfoReportFields = () => {
    return right?.map((field: any, index: any) => ({
      FieldName: field.field || field?.fieldName,
      FieldOrder: index,
      Sorting: false,
      FieldMappingId: field.fieldMappingId,
      FileInfoReportID: field?.fileInfoReportID || null,
      SearchQueryID: field?.searchQueryID || null,
    }));
  };

  useEffect(() => {
    getData(leftData, right, criteria, formData?.reportFormat);
    let data = {
      ReportName: formData.reportName,
      ReportType: formData.reportFormat,
      ToEmail: formData.toEmail,
      CCEmail: formData.ccEmail,
      BCCEmail: formData.bccEmail,
      AccountID: LocalStorageUtil.getItem("accountId"),
      SearchCriterias: generateSearchCriterias(leftData),
      contextName: LocalStorageUtil.getItem("contextName"),
      savedRightData: generateFileInfoReportFields(),
    };
    getDataPayload(data);
  }, [getData, formData]);

  useEffect(() => {
    if (clearTrigger) {
      setFormData((prev) => ({
        ...prev,
        reportName: "",
        toEmail: "",
        bccEmail: "",
        ccEmail: "",
        emailId: "",
        reportFormat: "",
        isPublic: false,
      }));
      setCriteria([
        { id: Date.now(), condition: "", field: "", operator: "", value: "" },
      ]);
      setRight([])
      setStartDate(null);
      setEndDate(null);
      setSavedQueryDetails([])
    }
  }, [clearTrigger]);

  const handleCreate = async () => {
     const errors: any = {};
        let criteriaValidationErrors: any[] = [];        
    
      if (!formData.reportName?.trim()) {
        errors.reportName = "Please select the Report Name";
      }
      if (!formData.toEmail?.trim()) {
        errors.toEmail = "to Email is required.";
      }
      criteria.forEach((item, index) => {
        const rowErrors: any = {};
        if (!item.field?.trim()) rowErrors.field = "Please select the Field";
        if (!item.operator?.trim()) rowErrors.operator = "Please select the Operator";
        if (!item.value?.toString().trim()) rowErrors.value = "Please enter the Value1";
      
        criteriaValidationErrors[index] = rowErrors;
      });
    
      if (right.length === 0) {
        setErrors(prev => ({
          ...prev,
          selectedFieldsError: "Please select the Enabled Fields",
        }));
       
      } else {
        setErrors(prev => ({
          ...prev,
          selectedFieldsError: undefined,
        }));
      }
      const hasFormErrors = Object.keys(errors).length > 0;
      const hasCriteriaErrors = criteriaValidationErrors.some(
        (err) => Object.keys(err).length > 0
      );
    
      if (hasFormErrors || hasCriteriaErrors) {
        setFormErrors(errors);
        setCriteriaErrors(criteriaValidationErrors);
        return;
      }

      setFormErrors({
        reportName: "",
        toEmail: "",
        bccEmail: "",
        ccEmail: "",
      });
    
      setCriteriaErrors([]);
    const payload = {
      schedulerfileinfoobj: {
        contextName: LocalStorageUtil.getItem("contextName"),
        schedulerobj: {
          ReportName: formData.reportName,
          ToEmail: formData.toEmail,
          CCEmail: formData.ccEmail,
          BCCEmail: formData.bccEmail,
          RepeatType: Number(selectedRepeat),
          RepeatFrequency: repeatValue,
          RepeatOndata: repeatOn.map((id) => ({ id })),
          ReportQueueTypedata: [],
          ScheduleReportId:
            savedQueryDetails?.schedularData?.[0]?.scheduleReportId ?? null,
          RepeatOn: 62,
          StartDate: moment.utc(startDate).local().format("YYYY-MM-DD HH:mm"),
          EndDate: moment.utc(endDate).local().format("YYYY-MM-DD HH:mm"),
          NextRunDate: savedQueryDetails?.schedularData?.[0]?.nextRunDate ?? "",
          CreatedBy: Number(LocalStorageUtil.getItem("userId")),
          AccountId: Number(LocalStorageUtil.getItem("accountId")),
          Active: true,
          Timezone: appSettings.timezone,
        },
      },
      searchCriteriaDetailsModel: {
        searchCriteriaDetailsModel: {
          SearchCriterias: generateSearchCriterias(leftData),
          IsPublic: formData.isPublic,
          ModuleType: 4,
          SearchQueryName: formData.reportName,
          SearchQueryID:
            savedQueryDetails?.listSearchCriteriaDetailsModel?.[0]
              ?.searchQueryID ?? null,
          IsActive: true,
          AccountID: Number(LocalStorageUtil.getItem("accountId")),
          CreatedBy: Number(LocalStorageUtil.getItem("userId")),
          ReportType: formData.reportFormat,
          FileInfoReportFields: generateFileInfoReportFields(),
        },
        contextName: LocalStorageUtil.getItem("contextName"),
      },
    };
    try {
      setLoading(true);
      await createScheduleQuery(payload);
      saveQuery();
      if(!savedQueryDetails?.schedularData?.[0]?.scheduleReportId){
      showSnackbar("Report-Scheduler created Successfully")
      }else{
        showSnackbar("Report-Scheduler updated Successfully")
      }
      setLoading(false);
      handleCallback();
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid>
      <div className="ag-theme-quartz-dark">
        <Form>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)" ,fontSize: "11px"}}
                >
                  Report Name<span className="required">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the Report Name"
                  name="reportName"
                  value={formData.reportName}
                  onChange={handleChange}
                  isInvalid={!!formErrors.reportName}
                  required
                  disabled={savedQueryDetails?.schedularData?.length}
                  style={{fontSize: "11px"}}
                />
                {formErrors.reportName && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.reportName}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  To Email ID<span className="required">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter the To Email ID"
                  name="toEmail"
                  value={formData.toEmail}
                  onChange={handleChange}
                  isInvalid={!!formErrors.toEmail}
                  required
                  style={{fontSize: "11px"}}
                />
                {formErrors.toEmail && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.toEmail}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  CC Email ID
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter the CC Email ID"
                  name="ccEmail"
                  value={formData.ccEmail}
                  onChange={handleChange}
                  isInvalid={!!formErrors.ccEmail}
                  style={{fontSize: "11px"}}
                />
                {formErrors.ccEmail && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.ccEmail}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)" ,fontSize: "11px"}}
                >
                  BCC Email ID
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter the BCC Email ID"
                  name="bccEmail"
                  value={formData.bccEmail}
                  onChange={handleChange}
                  isInvalid={!!formErrors.bccEmail}
                  style={{fontSize: "11px"}}
                />
                {formErrors.bccEmail && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.bccEmail}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formRepeat">
                <Form.Label
                  className="input-labels"
                  style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                >
                  Repeats<span className="required">*</span>
                </Form.Label>
                <Form.Select
                  name="repeatFrequency"
                  value={selectedRepeat}
                  onChange={handleRepeatChange}
                  required
                  style={{fontSize: "11px"}}
                >
                  {ScheduleData.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.record}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              {["1", "5", "7", "8"].includes(selectedRepeat) && (
                <Form.Group controlId="formRepeatValue">
                  <Form.Label
                    className="input-labels"
                    style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                  >
                    Repeat Every<span className="required">*</span>
                  </Form.Label>
                  <Form.Select
                    name="repeatValue"
                    value={repeatValue}
                    onChange={handleRepeatValueChange}
                    required
                    style={{fontSize: "11px"}}
                  >
                    {ScheduleDay.map((option) => (
                      <option key={option.id} value={option.record}>
                        {option.record}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
              {selectedRepeat === "1" && (
                <span style={{ color: "var(--aggrid-text-color)" ,fontSize: "11px"}}>days</span>
              )}
              {selectedRepeat === "5" && (
                <span style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}>weeks</span>
              )}
              {selectedRepeat === "7" && (
                <span style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}>
                  months
                </span>
              )}
              {selectedRepeat === "8" && (
                <span style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}>years</span>
              )}
            </Col>
            <Col md={3}>
              {selectedRepeat === "5" && (
                <>
                  <Form.Label
                    className="input-labels"
                    style={{ color: "var(--aggrid-text-color)",fontSize: "11px" }}
                  >
                    Repeated On<span className="required">*</span>
                  </Form.Label>
                  <div
                    className="days-checkboxes"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    {daysArray.map((day) => (
                      <Form.Check
                        key={day.id}
                        type="checkbox"
                        label={day.day}
                        name={`day_${day.day}`}
                        className="day-checkbox"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "11px",
                          color: "var(--aggrid-text-color)",
                          gap: "5px",
                        }}
                        checked={
                          Array.isArray(repeatOn) && repeatOn.includes(day.id)
                        }
                        onChange={(e) => handleDayChange(e, day.id)}
                      />
                    ))}
                  </div>
                </>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={3} xs={12}>
              <InputLabel
                sx={{
                  fontWeight: 600,
                  fontSize: "11px",
                  color: "var(--text-color)",
                }}
              >
                Starts On
              </InputLabel>
              <DatePicker
                selected={startDate}
                placeholderText="Select From Date"
                onChange={(date) => setStartDate(date)}
                showTimeSelect
                timeIntervals={30}
                minDate={new Date()}
                timeFormat="HH:mm"
                dateFormat="yyyy-MM-dd HH:mm"
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
                required
                customInput={
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"                    
                    sx={{
                      height: "30px", 
                      backgroundColor: "white",
                      borderRadius: "4px",
                      width: "20vw",
                      "& .MuiOutlinedInput-root": {
                        height: "30px", 
                        "& input": {
                          fontSize: "11px", 
                          padding: "8px 10px",
                        },
                      },
                    }}
                  />
                }
              />
            </Col>
            <Col md={3}>
              <InputLabel
                sx={{
                  fontWeight: 600,
                  fontSize: "11px",
                  color: "var(--text-color)",
                }}
              >
                Ends On
              </InputLabel>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                placeholderText="Select End Date"
                showTimeSelect
                timeIntervals={30}
                minDate={new Date()}
                timeFormat="HH:mm"
                dateFormat="yyyy-MM-dd HH:mm"
                required
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
                customInput={
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    sx={{
                      height: "30px", 
                      backgroundColor: "white",
                      borderRadius: "4px",
                      width: "20vw",
                      "& .MuiOutlinedInput-root": {
                        height: "30px", 
                        "& input": {
                          fontSize: "11px", 
                          padding: "8px 10px",
                        },
                      },
                    }}
                  />
                }
              />
            </Col>
          </Row>
          <div style={{ marginTop: "20px" }}>
            <Row className="mb-3">
              <Col md={3}>
                <Form.Group controlId="formCustomer">
                  <Form.Label
                    className="input-labels"
                    style={{
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    Report Format<span className="required">*</span>
                  </Form.Label>
                  <Form.Select
                    name="reportFormat"
                    value={formData.reportFormat}
                    onChange={handleChange}
                    style={{fontSize: "11px"}}
                  >
                    <option value="">Select</option>
                    <option value="1">Html</option>
                    <option value="2">Excel</option>
                    <option value="3">Pdf</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formApiUser">
                  <Form.Label
                    className="input-labels"
                    style={{
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    As Public<span className="required">*</span>
                  </Form.Label>
                  <Form.Check
                    type="checkbox"
                    label={
                      <span
                        style={{
                          fontSize: "11px",
                          color: "var(--aggrid-text-color)",
                        }}
                      >
                        Public can be seen by other users
                      </span>
                    }
                    name="isPublic"
                    className="input-labels"
                    style={{ color: "var(--aggrid-text-color)" }}
                    checked={formData.isPublic}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div style={{ paddingTop: "20px", borderRadius: "10px" }}>
              <h6
                style={{
                  color: "var(--aggrid-text-color)",
                  marginBottom: "1rem",
                  fontSize: "11px",
                }}
              >
                Select Report Criteria *
              </h6>
              <Row className="align-items-center mb-2">
                <Col md={2}>
                  <Form.Label
                    className="input-labels"
                    style={{
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    AND/OR
                  </Form.Label>
                </Col>
                <Col md={3}>
                  <Form.Label
                    className="input-labels"
                    style={{
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    Field
                  </Form.Label>
                </Col>
                <Col md={3}>
                  <Form.Label
                    className="input-labels"
                    style={{
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    Operator
                  </Form.Label>
                </Col>
                <Col md={3}>
                  <Form.Label
                    className="input-labels"
                    style={{
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    Value1
                  </Form.Label>
                </Col>
                <Col md={1}></Col>
              </Row>

              {criteria?.map((item, index) => (
                <Row key={item.id} className="align-items-center mb-2">
                  <Col md={2}>
                    {index !== 0 && (
                      <Form.Select
                        name="condition"
                        value={item.condition}
                        onChange={(e) => handleCriteriaChange(item.id, e)}
                        style={{ fontSize: "11px" }}
                      >
                        <option value="">Select</option>
                        <option value="AND">AND</option>
                        <option value="OR">OR</option>
                      </Form.Select>
                    )}
                  </Col>
                  <Col md={3}>
                    <Form.Select
                      name="field"
                      value={item.field}
                      onChange={(e) => handleCriteriaChange(item.id, e)}
                      isInvalid={!!criteriaErrors[index]?.field}
                      style={{ fontSize: "11px" }}
                    >
                      <option value="">Select</option>
                      {fieldsData.map((fields: any, index: any) => (
                        <optgroup key={fields.label} label={fields.label}>
                          {fields.options.map((option: any) => (
                            <option key={option.value} value={option.label}>
                              {option.label}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
  {criteriaErrors[index]?.field}
</Form.Control.Feedback>
                  </Col>
                  <Col>
                  <Form.Select
                      name="operator"
                      value={item.operator}
                      onChange={(e) => handleCriteriaChange(item.id, e)}
                      isInvalid={!!criteriaErrors[index]?.operator}
                      style={{ fontSize: "11px" }}
                    >
                      <option value="">Select</option>
                      {(item.field?.toLowerCase().includes("date") ? dateOperator : operator).map((op) => (
                        <option key={op.value} value={op.value}>
                          {op.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
  {criteriaErrors[index]?.operator}
</Form.Control.Feedback>
                  </Col>
<Col md={3}>
  {item.field?.toLowerCase().includes("date") ? (
    <>
      <Form.Control
        type="date"
        placeholder="From Date"
        name="value"
        max={new Date().toISOString().split("T")[0]}
        value={item.value || ""}
        onChange={(e) => handleCriteriaChange(item.id, e)}
        isInvalid={!!criteriaErrors[index]?.value}
        style={{
          padding: ".3em",
          fontSize: "11px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          borderColor: "black",
          marginTop: ".1em",
          height: "30px",
        }}
      />
      <Form.Control.Feedback type="invalid">
        {criteriaErrors[index]?.value}
      </Form.Control.Feedback>
    </>
  ) : (
    <>
      <Form.Control
        type="text"
        name="value"
        placeholder="Enter Value"
        value={item.value}
        onChange={(e) => handleCriteriaChange(item.id, e)}
        isInvalid={!!criteriaErrors[index]?.value}
        style={{ fontSize: "11px" }}
      />
      <Form.Control.Feedback type="invalid">
        {criteriaErrors[index]?.value}
      </Form.Control.Feedback>
    </>
  )}
</Col>

                  <Col md={1} className="d-flex gap-2">
                    {criteria.length > 1 && (
                      <IconButton
                        size="medium"
                        sx={{
                          padding: 0,
                          marginLeft: "8px",
                          color: "inherit",
                        }}
                        onClick={() => removeCriteria(item.id)}
                      >
                        <DeleteOutlineIcon
                          fontSize="medium"
                          sx={{ color: "var(--text-color)" }}
                        />
                      </IconButton>
                    )}
                    <IconButton
                      size="medium"
                      sx={{
                        padding: 0,
                        marginLeft: "8px",
                        color: "inherit",
                      }}
                      onClick={addCriteria}
                    >
                      <AddIcon
                        fontSize="medium"
                        sx={{ color: "var(--text-color)" }}
                      />
                    </IconButton>
                  </Col>
                </Row>
              ))}
            </div>
            <Row style={{ marginTop: "2rem" }}>
              <h6
                style={{
                  color: "var(--aggrid-text-color)",
                  marginBottom: "1rem",
                  fontSize: "11px",
                }}
              >
                Select Fields and Order
              </h6>
              

              <DragDropContext onDragEnd={handleDragEnd}>
                <Row style={{ margin: "10px" }}>
                  {/* Left (Available) */}
                  <Col md={4}>
                    <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)" ,fontSize: "11px"}}>
                      Available<span className="required">*</span>
                    </Form.Label>
                    <TextField
                      fullWidth
                      placeholder="Search"
                      value={searchTermLeft}
                      onChange={handleSearchChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        bgcolor: "white",
                        marginBottom: "10px",
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-root": {
                          height: "35px",
                          borderRadius: "8px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#888",
                          },
                          "& input": {
        fontSize: "11px", 
      }
                        },
                      }}
                      variant="outlined"
                    />
                    <Droppable droppableId="available">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{
                            width: "100%",
                            height: "490px",
                            overflow: "auto",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            fontSize: "11px",
                          }}
                        >
                          {left
                            .filter(
                              (item: any) =>
                                searchTermLeft === "" ||
                                item?.field?.toLowerCase().includes(searchTermLeft.toLowerCase()) ||
                                item?.fieldName?.toLowerCase().includes(searchTermLeft.toLowerCase())
                            )
                            .map((item: any, index: number) => (
                              <Draggable
                                key={item.mappingAutoId || item.metaDataFieldId || item.fileInfoReportID}
                                draggableId={`${item.mappingAutoId || item.metaDataFieldId || item.fileInfoReportID}`}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={{
                                      ...provided.draggableProps.style,
                                      padding: "8px",
                                      margin: "4px",
                                      backgroundColor: "white",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "grab",
                                      color: "black",
                                    }}
                                  >
                                    {`${String(index + 1).padStart(2, "0")}. ${item.category ? `${item.category} - ` : ""}${item.field || item.fieldName}`}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </Col>
              
                  {/* Center (Undo) */}
                  <Col
                    md={1}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={undoLastAction}
                      disabled={history.length === 0}
                      aria-label="undo last action"
                      style={{
                        color: "var(--aggrid-text-color)",
                        border: "1px solid var(--aggrid-text-color)",
                      }}
                    >
                      <RefreshIcon />
                    </Button>
                  </Col>
              
                  {/* Right (Enabled) */}
                  <Col md={4}>
                    <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize: "11px"}}>
                      Enabled<span className="required">*</span>
                    </Form.Label>
                    <TextField
                      fullWidth
                      placeholder="Search"
                      value={searchTermRight}
                      onChange={handleSearchChangeRight}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        bgcolor: "white",
                        borderRadius: "8px",
                        marginBottom: "10px",
                        "& .MuiOutlinedInput-root": {
                          height: "35px",
                          borderRadius: "8px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#888",
                          },
                          "& input": {
        fontSize: "11px", 
      }
                        },
                      }}
                      variant="outlined"
                    />
                <Droppable droppableId="enabled">
  {(provided) => (
    <div
      {...provided.droppableProps}
      ref={provided.innerRef}
      style={{
        width: "100%",
        height: "490px",
        overflow: "auto",
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      {right?.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            color: "gray",
            marginTop: "20px",
            fontSize: "0.9rem",
          }}
        >
          No items available...
        </div>
      ) : (
        right
          .filter(
            (item: any) =>
              searchTermRight === "" ||
              item?.field?.toLowerCase().includes(searchTermRight.toLowerCase()) ||
              item?.fieldName?.toLowerCase().includes(searchTermRight.toLowerCase())
          )
          .map((item: any, index: number) => {
            const itemKey = item?.metaDataFieldId || item?.fileInfoReportID || item?.mappingAutoId;

            return (
              <Draggable key={itemKey} draggableId={`${itemKey}`} index={index}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      ...provided.draggableProps.style,
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 12px",
                      margin: "4px 8px",
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      cursor: "grab",
                      fontSize: "11px",
                      color: "black",
                    }}
                  >
                    {`${String(index + 1).padStart(2, "0")}. `}
                    
                      {item.category ? `${item.category} - ` : ""}
                      {item.field || item.fieldName}
                   
                  </div>
                )}
              </Draggable>
            );
          })
      )}
      {provided.placeholder}
    </div>
  )}
</Droppable>

                    {errors.selectedFieldsError && (
    <div style={{ color: "red", fontSize: "0.85rem", marginTop: "4px" }}>
      {errors.selectedFieldsError}
    </div>
  )}
                  </Col>
                </Row>
              </DragDropContext>
            </Row>
          </div>
          <Grid
            item
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            {savedQueryDetails?.schedularData?.length ? (
              <Button
                variant="contained"
                className="update-button"
                onClick={handleCreate}
              >
                Update
              </Button>
            ) : (
              <Button
                variant="contained"
                className="update-button"
                onClick={handleCreate}
              >
                Create
              </Button>
            )}
            <Button
              variant="contained"
              className="cancel-button"
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
          </Grid>
        </Form>
        <ConfirmDialog
          open={confirmDialogOpen}
          onClose={handleConfirmDialogClose}
          title="File Info Report"
          content="Are you sure you want to Cancel?"
        />
      </div>
    </Container>
  );
};
export default ScheduleFileInfoReport;
